import Piwik from './PiwikService.js';
import GTMService from './GTMService.js';
import trackingConfig from './tracker.config.js';
import TrackerProvider from './TrackerProvider.js';
import trackerRun from './tracker.run.js';

/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 21.01.15.
 */

/**
 *
 */
angular
  .module('farmnet.base.tracking', [
    'ngRoute',
    'farmnet.base',
    'angulartics.piwik',
    'angular-md5'
  ])
  .service('piwik', Piwik)
  .service('gtm', GTMService)
  .config(trackingConfig)
  .provider('tracker', TrackerProvider)
  .run(trackerRun);
